import Vue from 'vue';

/**
 * Library initialization
 */
import './init/fontawesome';

/**
 * Main application pieces
 */
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/app.scss';

/**
 * Router middleware that handles the changing of the document title
 */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  return next();
});

/**
 * Instantiate Vue
 */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
